import round from "lodash/round";
import { getTransformedMinutes } from "../../../../utilities/helpers";

export const getInjectionMouldingDayColumns = () => {
  return [
    {
      title: "Shift",
      dataIndex: "name",
      key: "shift",
      render: (value) => (value ? value : '--'),
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Shots (Nos)",
      dataIndex: ["stats", "total_shots"],
      key: "total_shots",
      render: (value) => (value ? round(value) : 0),
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Counts (Nos)",
      dataIndex: ["stats", "total_count"],
      key: "total_counts",
      render: (value) => (value ? value : 0),
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Power Consumption (KWH)",
      dataIndex: ["stats", "total_power_consumption"],
      key: "total_power_consumption",
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      render: (value) => (value ? round(value,2) : 0),

      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Idle Time",
      dataIndex: ["stats", "total_idle_hours"],
      key: "total_idle_hours",
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
      render: (text) => <>{getTransformedMinutes(Number(round(text)))||0}</>,
    },
    {
      title: "Machine Eff(%)",
      dataIndex: ["stats", "machine_efficiency"],
      key: "machine_efficiency",
      render: (value) => (value ? value : 0),
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Availability Ratio (%)",
      dataIndex: ["stats", "availablity_ratio"],
      render: (value) => (value ? round(value) : 0),
      key: "availablity_ratio",
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
    {
      title: "Quality Ratio (%)",
      dataIndex: ["stats", "quality_ratio"],
      key: "quality_ratio",
      render: (value) => (value ? value : 0),
      onHeaderCell: () => ({
        style: { padding: "4px", textAlign: "center" },
      }),
      onCell: () => ({
        style: {
          padding: "2px",
          paddingTop: "14px",
          paddingBottom: "14px",
          textAlign: "center",
        },
      }),
    },
  ];
};
